"use client";

import React from "react";
import { Plane, Briefcase, GlassWater, MapPin, Building2, ArrowRight, Users, Briefcase as Luggage, Wifi, MonitorPlay, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const services = [{
  title: "Avv. Federico Borromeo",
  description: "Senior Partner specializzato in diritto societario e governance, con oltre vent'anni di esperienza in operazioni straordinarie.",
  icon: Briefcase,
  colSpan: "md:col-span-4"
}, {
  title: "Avv. Beatrice d'Este",
  description: "Esperta in Diritto Penale d'Impresa e compliance normativa, coordina il dipartimento dedicato alla responsabilità degli enti.",
  icon: Sparkles,
  colSpan: "md:col-span-4"
}, {
  title: "Dr. Ludovico Sforza",
  description: "Consulente strategico per l'internazionalizzazione delle imprese, assiste i clienti nello sviluppo di mercati esteri.",
  icon: Plane,
  colSpan: "md:col-span-4"
}, {
  title: "Avv. Isabella Gonzaga",
  description: "Specialista in Diritto Amministrativo e appalti pubblici, con un focus particolare sulla transizione ecologica e PNRR.",
  icon: MapPin,
  colSpan: "md:col-span-6"
}, {
  title: "Avv. Gian Galeazzo",
  description: "Responsabile del Contenzioso Civile e Arbitrati, esperto nella risoluzione di dispute commerciali complesse.",
  icon: Building2,
  colSpan: "md:col-span-6"
}];
const fleet = [{
  name: "Responsabilità 231",
  model: "Compliance & Governance",
  description: "Progettazione e implementazione di Modelli di Organizzazione, Gestione e Controllo ai sensi del D.Lgs. 231/01. Un approccio sartoriale per mitigare i rischi aziendali e garantire l'etica professionale.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/fleet_suv_black.png",
  specs: [{
    label: "Esperti",
    value: "4",
    icon: Users
  }, {
    label: "Pratiche",
    value: "120+",
    icon: Luggage
  }, {
    label: "Digitale",
    value: "Sì",
    icon: Wifi
  }]
}, {
  name: "Diritto Penale",
  model: "White Collar Crime",
  description: "Difesa tecnica d'eccellenza nei procedimenti per reati economici, tributari e ambientali. Assistenza giudiziale e stragiudiziale caratterizzata da rigore analitico e massima riservatezza.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/fleet_sedan_luxury.png",
  specs: [{
    label: "Senior",
    value: "3",
    icon: Users
  }, {
    label: "Archivio",
    value: "Cloud",
    icon: Luggage
  }, {
    label: "Eccellenza",
    value: "Certificata",
    icon: Sparkles
  }]
}, {
  name: "Consulenza Internazionale",
  model: "Cross-border Advisory",
  description: "Supporto legale per l'espansione globale. Gestione di contrattualistica internazionale, joint venture e contenziosi transfrontalieri con una visione integrata dei sistemi giuridici.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/fleet_sprinter_van.png",
  specs: [{
    label: "Partner",
    value: "Global",
    icon: Users
  }, {
    label: "Documenti",
    value: "Multilingua",
    icon: Luggage
  }, {
    label: "Review",
    value: "Real-time",
    icon: MonitorPlay
  }]
}];
function EditorialBlogFeed() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="149852" className="grid grid-cols-1 lg:grid-cols-12 gap-8 animate-pulse">
        <div className="lg:col-span-7 h-[600px] bg-muted/20 rounded-xl"></div>
        <div className="lg:col-span-5 flex flex-col gap-8">
          <div className="h-[280px] bg-muted/20 rounded-xl"></div>
          <div className="h-[280px] bg-muted/20 rounded-xl"></div>
        </div>
      </div>;
  }
  if (error || posts.length === 0) {
    return null;
  }
  const featuredPost = posts[0];
  const sidePosts = posts.slice(1, 3);
  return <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
      {}
      {featuredPost && <article data-index={0} className="lg:col-span-7 group relative flex flex-col">
          <Link to={featuredPost.link || "#"} className="block overflow-hidden rounded-xl mb-6">
            <AspectRatio ratio={16 / 10}>
              <img src={featuredPost.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/blog_placeholder_1.png"} alt={featuredPost.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
            </AspectRatio>
          </Link>
          <div className="flex flex-col flex-grow justify-end">
            <div className="flex items-center gap-3 mb-4">
              {featuredPost.categories?.[0] && <Badge variant="outline" className="border-primary/50 text-primary rounded-none uppercase tracking-widest text-[10px] font-mono">
                  {featuredPost.categories[0].name}
                </Badge>}
              <span className="text-xs text-muted-foreground font-mono uppercase tracking-wider">
                {featuredPost.date ? new Date(featuredPost.date).toLocaleDateString("it-IT", {
              month: "long",
              day: "numeric",
              year: "numeric"
            }) : "Recente"}
              </span>
            </div>
            <Link to={featuredPost.link || "#"} className="group-hover:text-primary transition-colors">
              <h3 className="article-title text-3xl md:text-4xl lg:text-5xl font-serif leading-tight mb-4 tracking-tight">
                {featuredPost.title}
              </h3>
            </Link>
            <p className="text-muted-foreground line-clamp-3 mb-6 max-w-2xl text-lg">
              {featuredPost.excerpt?.replace(/<[^>]*>/g, "") || ""}
            </p>
            <Link to={featuredPost.link || "#"}>
              <Button variant="link" className="p-0 h-auto text-primary hover:text-primary/80 font-serif italic text-xl">
                Leggi l&apos;articolo completo <ArrowRight className="ml-2 size-4" />
              </Button>
            </Link>
          </div>
        </article>}

      {}
      {sidePosts.length > 0 && <div className="lg:col-span-5 flex flex-col gap-8">
          {sidePosts.map((post, i) => <React.Fragment key={post.id}>
              {i > 0 && <Separator className="bg-border/20" />}
              <article data-index={i + 1} className="group grid grid-cols-1 sm:grid-cols-5 gap-6 items-center">
                <Link to={post.link || "#"} className="sm:col-span-2 block overflow-hidden rounded-lg">
                  <AspectRatio ratio={1}>
                    <img src={post.featuredImage || `/img/blog_placeholder_${i + 2}.png`} alt={post.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0" />
                  </AspectRatio>
                </Link>
                <div className="sm:col-span-3 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-3">
                    {post.categories?.[0] && <span className="text-[10px] text-primary uppercase tracking-widest font-mono font-semibold">
                        {post.categories[0].name}
                      </span>}
                  </div>
                  <Link to={post.link || "#"} className="group-hover:text-primary transition-colors">
                    <h4 className="article-preview-title text-xl md:text-2xl font-serif leading-snug mb-3">
                      {post.title}
                    </h4>
                  </Link>
                  <Link to={post.link || "#"}>
                    <span className="inline-flex items-center text-sm text-muted-foreground group-hover:text-foreground transition-colors font-mono uppercase tracking-tighter">
                      Leggi di più <ArrowRight className="ml-1 size-3" />
                    </span>
                  </Link>
                </div>
              </article>
            </React.Fragment>)}
        </div>}
    </div>;
}
export default function ServicesShowcase() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}